import React from "react";
import {Badge} from "react-bootstrap";
import {TemplateFile} from "../model";
import {Downloader} from "./Downloader";
import thumbnail from '../image/thumbnail.jpg'

type TemplateFileDisplayProps = {
    file: TemplateFile
}

export const TemplateFileDisplay = ({file} : TemplateFileDisplayProps) => {

    const now = new Date().getTime();

    return (
        <div
            className={`border rounded m-2 p-2 border-dark d-flex flex-column flex-lg-row gap-5 text-center text-lg-start align-items-center align-items-lg-stretch`}
            style={{
                backgroundColor: 'rgba(255,255,255,.5)'
            }}
        >
            <img
                src={
                    file.thumbnailFileName
                        ? `${process.env.REACT_APP_SERVER_URL}/images/thumbnails/${file.thumbnailFileName}?${now}`
                        : thumbnail
                }
                alt={'thumbnail'}
                className={`rounded border border-dark-subtle`}
                style={{
                    height: 200,
                    width: 150,
                    objectFit: 'contain'
                }}
            />
            <div
                className={`d-flex flex-column align-items-stretch justify-content-between w-100`}
            >
                <div>
                    <h2 className={`ff-netto text-primary text-decoration-underline`}>{file.name}</h2>
                    {
                        file.version &&
                            <Badge bg={"secondary"}>
                                {`Version : ${file.version}`}
                            </Badge>
                    }
                    {
                        file.description &&
                            <p className={'text-start'}>
                                {file.description}
                            </p>
                    }
                </div>
                <div className={`w-100 d-flex justify-content-center justify-content-lg-end`}>
                    <Downloader
                        id={file.id}
                        type={"template"}
                        text={`Télécharger le document`}
                    />
                </div>

            </div>
        </div>
    )
}